import { ArticleCategory, ArticleType } from '@nemuru-eng/js-api-client';

import { MinimalFormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/MinimalFormItem';

export const DefaultCartItem: MinimalFormItem = {
  units: '1',
  description: '',
  vat: '21',
  price: undefined, // this undefined value indicates the item has just been appended to CartItemDialog
  category: ArticleCategory.PHYSICAL,
  type: ArticleType.ONLINE_PRODUCT,
};
